import { render, staticRenderFns } from "./CbsModificationConstructor.vue?vue&type=template&id=49e43f10&scoped=true"
import script from "./CbsModificationConstructor.vue?vue&type=script&lang=js"
export * from "./CbsModificationConstructor.vue?vue&type=script&lang=js"
import style0 from "./CbsModificationConstructor.vue?vue&type=style&index=0&id=49e43f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e43f10",
  null
  
)

export default component.exports